import Vue from 'vue/dist/vue.common';
import { apolloProvider } from "../vue-apollo-init";
import gql from 'graphql-tag';
import _ from 'lodash';

export class Menu_Comps {
    constructor(){

        this.menu_categories = false;
        this.tag_list = false;
    }
    init(){
        let store = window.store;
        let router = window.router;
  
        this.menu_categories = new Vue({
            apolloProvider,
            apollo: {
              menu_categories: {
                query: gql`query getTaxonomies {
                  postTopics (first: 100) {
                    nodes {
                      id
                      databaseId
                      name
                      taxonomyName
                      taxonomy {
                        node {
                          graphqlSingleName
                        }
                      }                
                    }
                  }
                  postAuthors (first: 100) {
                    nodes {
                      id
                      databaseId
                      name
                      taxonomyName
                      taxonomy {
                        node {
                          graphqlSingleName
                        }
                      }
                    }
                  }
                  postCollaborators (first: 100) {
                    nodes {
                      id
                      databaseId
                      name
                      taxonomyName
                      taxonomy {
                        node {
                          graphqlSingleName
                        }
                      }
                    }
                  }
                  postLocations (first: 100) {
                    nodes {
                      id
                      databaseId
                      name
                      taxonomyName
                      taxonomy {
                        node {
                          graphqlSingleName
                        }
                      }
                    }
                  }
                }
                `,
                update (data) {
                  return data;
                }
              }
            },
            el: '#menu-cat-list',
            template: '#menu-cat-list-template',
            data: store.state,
            methods: {
              set_tag(tag_id, tag_title) {
                store.setTag({tag_id: tag_id, tag_title: tag_title});
                return false;
              },
              is_tag_active(tag_id, tag_title) {
                if(this?.posts_tags?.tag_id){
                  return tag_id == this.posts_tags.tag_id;
                } else {
                  return false;
                }
              },
              set_cat(cat_id, cat_type){
                store.setCat(cat_id, cat_type);
                return false;
              },
              is_cat_active(cat_id, cat_type) {
                //console.log(this.posts_cats);
                return _.some(this.posts_cats, {taxonomy: cat_type.toUpperCase(), terms: cat_id})
              },
              reset_all() {
                store.setCat(false, false);
                store.setTag(false);
                store.setSearchText('');
                store.setSearchActive(false);
              }
            }
          });
      
      
        this.tag_list = new Vue({
            apolloProvider,
            apollo: {
              tags: {
                query: gql`query getTags {
                  tags {
                    nodes {
                      id
                      databaseId
                      name
                    }
                  }
                }
                `,
                update (data) {            
                  return data.tags.nodes;
                }
              }
            },
            el: '#menu-tag-list',
            template: '#menu-tag-list-template',
            data: store.state,
            methods: {
              set_tag(tag_id, tag_title) {
                store.setTag({tag_id: tag_id, tag_title: tag_title});
                return false;
              },
              is_tag_active(tag_id, tag_title) {
                if(this?.posts_tags?.tag_id){
                  return tag_id == this.posts_tags.tag_id;
                } else {
                  return false;
                }
              },
            }
          });
      
    }
}